import { Alert, Button, Col, DatePicker, Form, Icon, Input, InputNumber, Row, Spin } from 'antd'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import withFormItemView from 'form-item-view-hoc'
import _, { get, isEmpty, round, sum } from 'lodash'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import OrdersApi from '../../../../api/Sales/Orders'
import SalesContractsApi from '../../../../api/Sales/SalesContracts'
import OnlineSalesModal from '../../../../components/Sales/Orders/OnlineSalesOrder/OnlineSalesModal'
import { PaymentTermsMethodSelect, ProductTypeSelect } from '../../../../components/Sales/Quotes/AddQuote/QuoteForm'
import DeliveryDetails from '../../../../elements/DeliveryDetails'
import withMapList from '../../../../elements/HOC/withMapList'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetch from '../../../../elements/Hooks/useFetch'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import IconText from '../../../../elements/IconText'
import InfoTooltip from '../../../../elements/InfoTooltip'
import MultiCurrency from '../../../../elements/MultiCurrency'
import RegisteredPartnerDetails from '../../../../elements/RegisteredPartnerDetails'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import Taxes from '../../../../elements/Taxes'
import ViewDownload from '../../../../elements/ViewDownload'
import Authentication from '../../../../modules/Authentication'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
} from '../../../../modules/FormItems'
import { dateVal, numVal, strVal } from '../../../../modules/Utils'
import { streamUrl } from '../../../../variables'

const { TextArea } = Input
const CustomFormItem = compose(withFormItemView)(Form.Item)
const salesContractsApi = new SalesContractsApi()
const auth = new Authentication()

function OrderForm(props) {
  const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue } = props.form
  const { order, type, FileSelectCmp, lines, onChangeContract, onChangeCompany, onChangeQuote, fetchingQuote } = props

  const owner = (getFieldValue('client._id') || '').replace('partners/', '')

  const contractID = getFieldValue('contract._id') || get(order, 'contract._id', '')
  const contractKey = contractID.replace('salesContracts/', '')
  const { object: contract, setObject: setContract } = useFetchObject(
    () => salesContractsApi.get(contractKey),
    false,
    [contractKey],
    isEmpty(contractKey)
  )

  useEffect(() => {
    if (!isEmpty(contract)) {
      setFieldsValue({
        centers: get(contract, 'budget.cost._id'),
        'company._id': get(contract, 'company._id'),
      })
      onChangeCompany(get(contract, 'company._id'))
    }
  }, [contract._rev])

  let quoteID = getFieldValue('quote._id') || get(order, 'quote._id')
  let quoteKey = quoteID && quoteID.replace('quotes/', '')

  let cpoFile = (getFieldValue('cpo.file') || get(order, 'cpo.file') || '').replace('files/', '')

  const [showDesc, setShowDesc] = React.useState(() => !isEmpty(order.description))

  const enquiryID = _.get(order, 'enquiry._id')
  const quoteURL = enquiryID
    ? `quotes?select=_id,code,title&status=Confirmed&enquiry=${enquiryID}`
    : 'quotes?select=_id,code,title&status=Confirmed'
  const QuoteSelect = compose(
    withUrlFetch({
      name: 'quotations',
      url: quoteURL,
      cache: true,
      forceFetch: false,
    }),
    withSpinning,
    withMapList((quote) => ({
      ...quote,
      display: `${quote.code} - ${quote.title} ${
        strVal(quote, 'enquiry.code') && `- (${strVal(quote, 'enquiry.code')})`
      }`,
    }))
  )(CustomSelect)

  const { data: line } = useFetch({
    url: 'https://orders.mmeagroup.com/api/' + get(order, 'onlineRef._id'),
    dependencyArray: [order],
    dontFetch: isEmpty(get(order, 'reference.no', false)) || !get(order, 'isOnlineOrder'),
    isExternal: true,
  })
  const onlineModal = useModalShow()

  const Api = new OrdersApi()
  const [syncing, onSync] = useSubmit(() => Api.sync(order._key))

  return (
    <Row>
      <Form layout={'horizontal'}>
        <Row>
          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h3 style={{ color: 'rgb(43,187,143' }}>SALES ORDER DETAILS</h3>
          </Row>
          {get(order, 'isSalesConfirmation', false) && (order.status === 'Revised' || order.status === 'Submitted') && (
            <Row>
              <Button loading={syncing} type="primary" onClick={onSync}>
                Sync w/ Enquiry
              </Button>
            </Row>
          )}
          <Row>
            <Col span={12}>
              {!get(order, 'isOnlineOrder', false) && !get(order, 'isSalesConfirmation', false) && (
                <Form.Item {...threeFormItemLayout} label={'Quote'}>
                  {getFieldDecorator('quote._id', {
                    initialValue: get(order, 'quote._id'),
                    rules: rules.select,
                  })(
                    <QuoteSelect
                      style={{ width: '80%' }}
                      onChange={onChangeQuote}
                      keyAtr={'_id'}
                      valueAtr={'display'}
                      placeholder={'Select a quote if Any'}
                    />
                  )}
                  <InfoTooltip title={'Quote must be confirmed to appear in List'} />
                  <Spin style={{ marginLeft: 10 }} spinning={fetchingQuote} />
                  <Link target={'_blank'} to={`/clients/quotes/${quoteKey}/update`}>
                    <Icon style={{ marginLeft: 5 }} type="fullscreen" />
                  </Link>
                </Form.Item>
              )}
              {get(order, 'isOnlineOrder', false) && !get(order, 'isSalesConfirmation', false) && (
                <>
                  <Button
                    style={{
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                    onClick={onlineModal.onShow}
                    type="primary">
                    Show Online Order
                  </Button>
                  <OnlineSalesModal {...{ ...onlineModal, line, readonly: true }} />
                </>
              )}
            </Col>

            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order For'}>
                {getFieldDecorator('orderType', {
                  initialValue: get(order, 'orderType'),
                  rules: rules.select,
                })(<ProductTypeSelect />)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order Date'}>
                {getFieldDecorator('date', {
                  initialValue: dateVal(order, 'date'),
                  rules: [{ required: true, message: 'Please Select a Order Date!' }],
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Title '}>
                {getFieldDecorator('title', {
                  initialValue: get(order, 'title'),
                  rules: [{ required: true, message: 'Please Select a Title!' }],
                })(<Input placeholder={'Title'} />)}
                <IconText
                  text={
                    showDesc !== true ? 'Optionally Add Order Summary Description' : 'Remove Order Summary Description'
                  }
                  type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
                  onClick={() => setShowDesc(!showDesc)}
                />
              </Form.Item>
            </Col>
          </Row>
          {showDesc === true && (
            <Row>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label={'Summary'}>
                  {getFieldDecorator('description', {
                    initialValue: get(order, 'description'),
                    rules: rules.input,
                  })(<TextArea placeholder={'Order Summary'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row>
            <Taxes
              doc={order}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'sale',
                price: numVal(order, 'subtotal.net'),
                hideRate: true,
              }}
            />
          </Row>
          <Row>
            <RegisteredPartnerDetails
              doc={order}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'sales',
                vendorID: owner,
                title: 'CLIENT DETAILS',
                showProfit: true,
                showRepEmail: true,
                isOnline: get(order, 'isOnlineOrder', false),
              }}
            />
          </Row>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>CLIENT PURCHASE ORDER DETAILS (CPO) </h3>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'CPO Date'}>
              {getFieldDecorator('cpo.date', {
                initialValue: dateVal(order, 'cpo.date'),
                rules: [{ required: true, message: 'Please Select a Date!' }],
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'CPO No.'}>
              {getFieldDecorator('cpo.no', {
                initialValue: strVal(order, 'cpo.no'),
              })(<Input placeholder={'Client Purchase Order No.'} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Reference No.'}>
              {getFieldDecorator('reference.no', {
                initialValue: get(order, 'reference.no'),
              })(<Input placeholder={'Client Reference No.'} disabled={get(order, 'isOnlineOrder', false)} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <MultiCurrency
            doc={order}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              type: 'sales',
            }}
          />
          <Col span={6}>
            <Form.Item {...defaultFormItemLayout} label={'Amount'}>
              {getFieldDecorator('cpo.amount', {
                initialValue: get(order, 'cpo.amount'),
              })(<InputNumber placeholder={'CPO Amount'} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...threeFormItemLayout}
              label={<InfoTooltip value={'CPO File'} title={'If empty; please upload files in documents tab.'} />}>
              {getFieldDecorator('cpo.file', {
                initialValue: get(order, 'cpo.file'),
              })(<FileSelectCmp style={{ width: '85%' }} keyAtr="_id" valueAtr="name" placeholder={'CPO File'} />)}
              &nbsp;
              <ViewDownload
                view={`${streamUrl}files/${cpoFile}?action=view&access_token=${auth.getAccessToken()}`}
                download={`${streamUrl}files/${cpoFile}?action=download&access_token=${auth.getAccessToken()}`}
                disabled={_.isEmpty(cpoFile)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {props.form.getFieldValue('cpo.amount') &&
            round(props.form.getFieldValue('cpo.amount'), 2) !==
              round(sum(props.lines.map((d) => numVal(d, 'amount.gross'))), 2) && (
              <Alert type="warning" message={'CPO Amount not matching lines value'} />
            )}
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>TERMS & CONDITIONS</h3>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Method'}>
              {getFieldDecorator('paymentTerms.method', {
                initialValue: get(order, 'paymentTerms.method') || 'Account',
                rules: [
                  {
                    required: true,
                    message: `Can't be empty.`,
                  },
                ],
              })(<PaymentTermsMethodSelect placeholder={'Method'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...threeFormItemLayout}
              label={<InfoTooltip value={'T & Cs File'} title={'If empty; please contact division manager'} />}>
              {getFieldDecorator('terms.file', {
                initialValue: get(order, 'terms.file'),
                // rules: rules.select,
              })(
                <FileSelectCmp
                  style={{ width: '85%' }}
                  keyAtr="_id"
                  valueAtr="name"
                  placeholder={'Terms & Conditions File'}
                />
              )}
              &nbsp;
              <ViewDownload
                view={`${streamUrl}files/${cpoFile}?action=view&access_token=${auth.getAccessToken()}`}
                download={`${streamUrl}files/${cpoFile}?action=download&access_token=${auth.getAccessToken()}`}
                disabled={_.isEmpty(cpoFile)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Additional Terms'}>
              {getFieldDecorator('paymentTerms.terms', {
                initialValue: get(order, 'paymentTerms.terms'),
              })(<TextArea placeholder={'Additional Terms'} />)}
            </Form.Item>
          </Col>
        </Row>

        <DeliveryDetails
          doc={order}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'Order',
            listId: get(contract, '_id'),
          }}
        />
      </Form>
    </Row>
  )
}

OrderForm.propTypes = {}
OrderForm.defaultProps = { order: {}, type: 'new' }

export default Form.create()(OrderForm)
